<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageapprovelist/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
